(() => {
  const root = document.querySelector('.lux-installation');
  if (!root) return;

  const input = root.querySelector('#LuxProjectPhotos');
  const dropzone = root.querySelector('#LuxUploadDropzone');
  const preview = root.querySelector('#LuxUploadPreview');
  const status = root.querySelector('#LuxUploadStatus');
  const form = root.querySelector('#LuxInstallationForm');
  const linksField = root.querySelector('#LuxUploadedImageLinks');
  const submit = root.querySelector('#LuxInstallationSubmit');

  if (!input || !dropzone || !preview || !form) return;

  const MAX_FILES = 8;
  const MAX_SIZE = 10 * 1024 * 1024;
  const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];
  let selectedFiles = [];

  const updateInputFiles = () => {
    const transfer = new DataTransfer();
    selectedFiles.forEach((file) => transfer.items.add(file));
    input.files = transfer.files;
  };

  const renderFiles = () => {
    preview.innerHTML = '';

    selectedFiles.forEach((file, index) => {
      const item = document.createElement('div');
      item.className = 'lux-upload-item';

      const thumb = document.createElement('div');
      thumb.className = 'lux-upload-item__thumb';

      if (file.type.startsWith('image/')) {
        const image = document.createElement('img');
        image.alt = file.name;
        image.src = URL.createObjectURL(file);
        image.addEventListener('load', () => URL.revokeObjectURL(image.src), { once: true });
        thumb.appendChild(image);
      } else {
        const pdf = document.createElement('div');
        pdf.className = 'lux-upload-item__pdf';
        pdf.textContent = file.name;
        thumb.appendChild(pdf);
      }

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'lux-upload-item__remove';
      remove.setAttribute('aria-label', `Remove ${file.name}`);
      remove.textContent = '×';
      remove.addEventListener('click', () => {
        selectedFiles.splice(index, 1);
        updateInputFiles();
        renderFiles();
      });

      item.append(thumb, remove);
      preview.appendChild(item);
    });

    status.textContent = selectedFiles.length
      ? `${selectedFiles.length} file${selectedFiles.length === 1 ? '' : 's'} selected.`
      : '';
  };

  const addFiles = (files) => {
    const incoming = Array.from(files);
    const errors = [];

    incoming.forEach((file) => {
      if (!allowedTypes.includes(file.type)) {
        errors.push(`${file.name}: unsupported file type.`);
        return;
      }
      if (file.size > MAX_SIZE) {
        errors.push(`${file.name}: larger than 10 MB.`);
        return;
      }
      if (selectedFiles.length >= MAX_FILES) {
        errors.push(`A maximum of ${MAX_FILES} files can be attached.`);
        return;
      }
      const duplicate = selectedFiles.some((existing) =>
        existing.name === file.name && existing.size === file.size && existing.lastModified === file.lastModified
      );
      if (!duplicate) selectedFiles.push(file);
    });

    updateInputFiles();
    renderFiles();
    if (errors.length) status.textContent = errors.join(' ');
  };

  input.addEventListener('change', (event) => addFiles(event.target.files));

  ['dragenter', 'dragover'].forEach((eventName) => {
    dropzone.addEventListener(eventName, (event) => {
      event.preventDefault();
      dropzone.classList.add('is-dragging');
    });
  });

  ['dragleave', 'drop'].forEach((eventName) => {
    dropzone.addEventListener(eventName, (event) => {
      event.preventDefault();
      dropzone.classList.remove('is-dragging');
    });
  });

  dropzone.addEventListener('drop', (event) => addFiles(event.dataTransfer.files));

  const uploadFiles = async () => {
    const endpoint = dropzone.dataset.uploadEndpoint?.trim();
    if (!selectedFiles.length || !endpoint) return [];

    const payload = new FormData();
    selectedFiles.forEach((file) => payload.append('files[]', file, file.name));

    const response = await fetch(endpoint, {
      method: 'POST',
      body: payload,
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw new Error('The project photos could not be uploaded.');
    const data = await response.json();
    if (!Array.isArray(data.urls)) throw new Error('The upload service returned an invalid response.');
    return data.urls;
  };

  form.addEventListener('submit', async (event) => {
    const endpoint = dropzone.dataset.uploadEndpoint?.trim();
    if (!selectedFiles.length || !endpoint || form.dataset.readyToSubmit === 'true') return;

    event.preventDefault();
    submit.disabled = true;
    submit.textContent = 'Uploading Photos…';
    status.textContent = 'Uploading project photos securely…';

    try {
      const urls = await uploadFiles();
      linksField.value = urls.join('\n');
      form.dataset.readyToSubmit = 'true';
      status.textContent = 'Photos uploaded. Submitting your request…';
      submit.textContent = 'Submitting Request…';
      form.requestSubmit();
    } catch (error) {
      submit.disabled = false;
      submit.textContent = 'Submit Installation Request';
      status.textContent = error.message || 'The files could not be uploaded. Please try again.';
    }
  });
})();
